<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat class="d-flex justify-center">
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @change="updateRange"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import {
  getSolraInverterMonthWork,
  getSolraMonthWork
} from '@/api/pcs/siteWork'
import { getOnlyCapa } from '@/api/master/master'

export default {
  name: 'InverterCalendar',
  props: {
    SITE_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    INVERTER_MODEL: { type: String, default: '' },
    tabIndex: { type: Number, default: 0 }
  },
  data: () => ({
    totalCapa: 0,
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      'blue',
      'indigo',
      'deep-purple',
      'cyan',
      'green',
      'orange',
      'grey darken-1'
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party'
    ]
  }),
  mounted() {
    this.$refs.calendar && this.$nextTick(() => {
      const cal = this.$refs.calendar
      if (cal.start && cal.end) {
        this.updateRange({ start: { date: cal.start }, end: { date: cal.end } })
      }
    })
  },
  methods: {
    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        )
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    updateRange({ start, end }) {
      this.events = []
      const postParam = {
        site_id: this.SITE_ID,
        inverter_id: this.INVERTER_ID,
        station_id: this.STATION_ID,
        startDate: start.date
      }
      const params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        start.date

      getOnlyCapa(postParam).then(rec => {
        const capa = rec?.[0]?.pcs_capa || 1

        const setEvents = (runData) => {
          if (!Array.isArray(runData)) return
          const isCurrentMonth = new Date(start.date).getMonth() === new Date().getMonth()
          const isCurrentYear = new Date(start.date).getFullYear() === new Date().getFullYear()
          const today = new Date().getDate()

          runData.forEach((val, i) => {
            const eventDate = this.returnDate(start.date, i)
            if (!(isCurrentMonth && isCurrentYear && today < i + 1)) {
              this.setEvt(`${Number(val).toFixed(1)}kWh`, eventDate, eventDate)
              this.setEvt(`${(val / capa).toFixed(1)} h`, eventDate, eventDate)
            }
          })
        }

        const handler = (res) => setEvents(res?.solraMonthWork?.runData)

        const fetchFn = this.STATION_ID ? getSolraInverterMonthWork : getSolraMonthWork
        fetchFn(params).then(handler).catch(console.error)
      }).catch(console.error)
    },
    setEvt(n, s, e) {
      this.events.push({
        name: n,
        start: s,
        end: e,
        color: '#202020',
        timed: false
      })
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    returnDate(baseDate, dayOffset) {
      const date = new Date(baseDate)
      date.setDate(dayOffset + 1)
      return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    }
  }
}
</script>

<style scoped>
</style>